<div class="auth-layout-wrapper">
  <router-outlet></router-outlet>
</div>
